<template>
  <div class="content ht-100v pd-0">
    <!-- <form-edit
      :prms.sync="formEdit"
      :show.sync="formEdit.show"
      @on-attach="showFile($event)"
      @on-form-posted="formPosted"
      @on-edit-close="editClosed"
    ></form-edit>-->

    <!-- <mention-users
      :show="projectMention.show"
      :obj.sync="project"
      module="form"
      @on-mention-close="projectMention.show= false"
    ></mention-users>-->

    <!-- <form-detail
      v-if="formDialog.id>0"
      :id.sync="formDialog.id"
      @on-attach="showFile($event)"
      @on-task-detail="showDetail"
      @on-task-reload="showDetail"
      @on-task-loaded="taskLoaded"
      @on-task-delete="onTaskDelete"
      @on-task-close="taskDialog.id=0; formLoaded()"
    ></form-detail>-->
    <!-- v-else -->
    <template>
      <div ref="mainHeader" class="content-header bd-b pd-0 bg-core-light">
        <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px;">
          <div class="dropdown" v-if="listSetting.mainMenu">
            <a
              class="navbar-brand tx-bold tx-spacing--2 order-1"
              data-toggle="dropdown"
              role="button"
            >
              <span v-if="this.ot == 1">Системийн лог</span>
              <span v-if="this.ot == 2">Алдааны лог</span>
            </a>
          </div>
          <div v-else-if="listSetting.closeBtnShow">
            <a
              class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto"
              @click="$emit('on-close')"
            >
              <feather type="x"></feather>
            </a>
          </div>
        </nav>
      </div>
      <div class="content-body pd-x-0 pd-y-0 overflow-hidden">
        <div class="container-fluid pd-x-0" id="cstmScrll">
          <div class="row no-gutters">
            <div class="col-xs-2 col-md-2 bg-core-light">
              <div
                v-if="listSetting.statisticLoad"
                class="row pd-x-10"
                ref="sideTop"
              >
                <!-- <div class="col-6">
                  <p
                    class="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 tx-nowrap mg-b-5"
                  >Хугацаа хэтэрсэн</p>
                  <div class="d-flex align-items-center" role="button">
                    <div class="wd-10 ht-10 rounded-circle bg-pink mg-r-5"></div>
                    <h5 class="tx-normal tx-rubik mg-b-0">
                      1,320
                      <small class="tx-color-04">25%</small>
                    </h5>
                  </div>
                </div>
                <div class="col-6">
                  <p class="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 mg-b-5">Шинэ</p>
                  <div class="d-flex align-items-center" role="button">
                    <div class="wd-10 ht-10 rounded-circle bg-primary mg-r-5"></div>
                    <h5 class="tx-normal tx-rubik mg-b-0">
                      987
                      <small class="tx-color-04">20%</small>
                    </h5>
                  </div>
                </div>
                <div class="col-6">
                  <p
                    class="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 mg-b-5"
                  >Хавчуурга 1</p>
                  <div class="d-flex align-items-center" role="button">
                    <div class="wd-10 ht-10 rounded-circle bg-teal mg-r-5"></div>
                    <h5 class="tx-normal tx-rubik mg-b-0">
                      2,010
                      <small class="tx-color-04">30%</small>
                    </h5>
                  </div>
                </div>
                <div class="col-6">
                  <p
                    class="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 mg-b-5"
                  >Хавчуурга 2</p>
                  <div class="d-flex align-items-center" role="button">
                    <div class="wd-10 ht-10 rounded-circle bg-orange mg-r-5"></div>
                    <h5 class="tx-normal tx-rubik mg-b-0">
                      1,054
                      <small class="tx-color-04">25%</small>
                    </h5>
                  </div>
                </div>-->
              </div>
              <vue-custom-scrollbar
                :style="`height:${scrSideHeight}px`"
                :settings="{ maxScrollbarLength: 60 }"
                class="bd-t"
              >
                <div class="pd-10">
                  <div class="el-form-item">
                    <label class="el-form-item__label">Хэрэглэгч</label>
                    <user-select-finder
                      @input="userFinded($event)"
                      v-model="searchModel.userId"
                    ></user-select-finder>
                  </div>
                  <div class="el-form-item">
                    <label class="el-form-item__label">IP хаяг</label>
                    <input
                      type="input"
                      class="el-input__inner"
                      v-model="searchModel.ipAddress"
                    />
                  </div>
                  <div class="el-form-item">
                    <label class="el-form-item__label">Path</label>
                    <input
                      type="input"
                      class="el-input__inner"
                      v-model="searchModel.path"
                    />
                  </div>

                  <div class="el-form-item">
                    <label class="el-form-item__label">Эхлэх</label>
                    <DatePicker
                      v-model="searchModel.start"
                      type="date"
                      class="wd-100p-f"
                    ></DatePicker>
                  </div>
                  <div class="el-form-item">
                    <label class="el-form-item__label">Дуусах</label>
                    <DatePicker
                      v-model="searchModel.end"
                      type="date"
                      class="wd-100p-f"
                    ></DatePicker>
                  </div>
                </div>
                <!-- <section v-for="(f,i) in searches" :key="i" class="pd-x-5">
                  <div v-if="f.flag==8" class="divider-text">{{f.title}}</div>
                  <template v-else>
                    <label
                      class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-t-5 mg-l-5"
                    >{{f.title}}</label>
                    <div v-if="f.flag==1" class="pd-x-5 mg-b-10">
                      <input
                        v-model="$data['filterModel'][f.field]"
                        type="text"
                        class="form-control input-sm"
                        :placeholder="`${f.title} бичнэ үү`"
                      />
                    </div>
                    <loc-type-cascader
                      v-else-if="f.flag==3"
                      :locTypekey="f.key"
                      v-model="$data['filterModel'][f.field]"
                      size="small"
                      :disableAdd="true"
                      class="pd-x-5 mg-b-10"
                    />

                    <drop-down
                      v-else-if="f.flag==33"
                      class="pd-x-5 mg-b-10"
                      v-model="$data['filterModel'][f.field]"
                      :key="`tsk_${i}`"
                    ></drop-down>
                    <task-finder
                      v-else-if="f.flag==85"
                      :mode="51"
                      class="pd-x-5 mg-b-10"
                      :selectedId="$data['filterModel'][f.field]"
                      v-model="$data['filterModel'][f.field]"
                      :objectTypeId.sync="[f.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                  </template>
                </section>-->
              </vue-custom-scrollbar>

              <div class="d-none d-md-block text-center bd-t" ref="sideBtm">
                <div
                  class="btn-group mg-y-7"
                  role="group"
                  aria-label="Basic example"
                >
                <button
                    @click="exportCoreHandle()"
                    type="button"
                    class="btn btn-xs btn-outline-light"
                  >
                    <feather type="download" size="32" class="mg-r-5"></feather>
                    <span>Экспорт</span>
                  </button>
                  <button
                    @click="search()"
                    type="button"
                    class="btn btn-xs btn-light"
                  >
                    <feather type="filter" class="mg-r-5"></feather>
                    <span>Хайх</span>
                  </button>
                  <button
                    @click="init(true)"
                    type="button"
                    class="btn btn-xs btn-light"
                  >
                    <feather type="refresh-ccw" class="mg-r-5"></feather>
                    <span>Бүгд</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-xs-10 col-md-10 bd-l">
              <div
                ref="listHeader"
                class="row no-gutters bg-list-header"
                v-show="logsCount > 0"
              >
                <div class="wd-5p text-center tx-10 align-items-center d-flex">
                  #
                </div>
                <div
                  :class="
                    `tx-10 align-items-center d-flex pd-y-7 text-black bd-l text-uppercase lh-1`
                  "
                  :style="`width: ${f.span}%`"
                  v-for="(f, i) in fields"
                  :key="i"
                >
                  {{ f.title }}
                </div>
              </div>

              <vue-custom-scrollbar
                :style="`height:${scrHeight}px`"
                :settings="{ maxScrollbarLength: 60 }"
              >
                <div v-if="!loading" class="d-list">
                  <div v-if="logsCount == 0" class>
                    <div class>
                      <div
                        class="ht-700 d-flex flex-column align-items-center justify-content-center"
                      >
                        <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
                          <img
                            src="assets/img/img22.png"
                            class="img-fluid"
                            alt
                          />
                        </div>
                        <p class="tx-color-03 mg-b-30">
                          Жагсаалт хоосон байна.
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- @click.prevent.stop="handleClick($event, t)" -->
                  <div v-else v-for="(l, i) in logs" :key="i" class="d-row">
                    <!-- <div v-show="isDrawGroupDateRange(i)" class="row no-gutters core-list-group">
                      <div class="col-12 text-muted">
                        <span class="pd-l-10 tx-12 tx-lowercase">{{l[showGroupLabel()]}}</span>
                      </div>
                    </div>-->
                    <div
                      role="button"
                      @click="showDetail(l)"
                      :class="
                        `row highlight no-gutters list-row ${
                          logDialog.id == l.id ? 'list-row-selected' : ''
                        }`
                      "
                    >
                      <div
                        class="wd-5p no-gutters align-items-center d-flex justify-content-end"
                      >
                        <div class="text-right text-muted pr-1 tx-11">
                          {{ (pager.current - 1) * pager.perPage + i + 1 }}
                        </div>
                        <div class="wd-25 text-center bd-l pt-1" @click.stop>
                          <input @click.stop type="checkbox" role="button" />
                        </div>
                      </div>

                      <div
                        :style="`width: 5%`"
                        class="tx-12 align-items-center d-flex bd-l"
                      >
                        <div class="pd-x-5 text">{{ l.id }}</div>
                      </div>
                      <div
                        :style="`width: 15%`"
                        class="tx-12 align-items-center d-flex bd-l"
                      >
                        <div class="pd-x-5 text">{{ l.user.fullName }}</div>
                      </div>
                      <div
                        :style="`width: 15%`"
                        class="tx-12 align-items-center d-flex bd-l"
                      >
                        <div class="pd-x-5 text">
                          {{ l.date | moment("YYYY.MM.DD HH:mm:ss dddd") }}
                        </div>
                      </div>
                      <div
                        :style="`width: 15%`"
                        class="tx-12 align-items-center d-flex bd-l"
                      >
                        <div class="pd-x-5 text">{{ l.path }}</div>
                      </div>
                      <div
                        :style="`width: 15%`"
                        class="tx-12 align-items-center d-flex bd-l"
                      >
                        <div class="pd-x-5 text">{{ l.ipAddress }}</div>
                      </div>
                      <div
                        :style="`width: 15%`"
                        class="tx-12 align-items-center d-flex bd-l"
                      >
                        <div class="pd-x-5 text">{{ l.browser }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else></div>
              </vue-custom-scrollbar>

              <div
                ref="listFooter"
                class="py-2 d-flex justify-content-between bd-t bg-core-light"
                v-show="logsCount > 0"
              >
                <div class="pd-x-5 pd-t-5 text-muted tx-12">
                  Нийт:
                  <span class="font-weight-bold">{{ logsCount }}</span> бичилт.
                  Харагдаж буй:
                  <span class="font-weight-bold">{{
                    (pager.current - 1) * pager.perPage + 1
                  }}</span>
                  -
                  <span class="font-weight-bold">{{
                    (pager.current - 1) * pager.perPage + logs.length
                  }}</span>
                </div>
                <div>
                  <b-pagination
                    size="sm"
                    align="center"
                    v-model="pager.current"
                    :total-rows="logsCount"
                    :per-page="pager.perPage"
                    @change="pageChanged"
                    style="margin-bottom: 0"
                  ></b-pagination>
                </div>
                <div>
                  <a @click="init(true)" role="button">
                    <feather
                      type="refresh-cw"
                      class="wd-20 ht-20 text-muted mg-r-10 mg-t-5"
                    ></feather>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <b-modal
      v-model="logDialog.show"
      @hide="cancel()"
      hide-footer
      hide-header
      centered
      body-class="pd-0"
    >
      <div v-if="logDialog.show">
        <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
          <a
            role="button"
            @click="cancel()"
            aria-label="Close"
            class="close pos-absolute t-15 r-15"
          >
            <span aria-hidden="true">×</span>
          </a>
          <div class="media align-items-center">
            <feather type="activity"></feather>
            <div class="media-body mg-sm-l-20">
              <h4 class="tx-18 tx-sm-20 mg-b-2">Хүсэлтийн дэлгэрэнгүй</h4>
              <p class="tx-13 tx-color-03 mg-b-0">
                Хүсэлтийн дэлгэрэнгүй мэдээлэл
              </p>
            </div>
          </div>
        </div>
        <div v-if="logDialog.show" class="modal-body">
          <div>
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >ID</label
            >
            <p class="mg-b-20">{{ log.id }}</p>
          </div>
          <div>
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >Нэвтрэх нэр / Овог нэр</label
            >
            <p class="mg-b-20">
              {{ log.user.loginName }} / {{ log.user.fullName }}
            </p>
          </div>
          <div>
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >Нэгж / Албан тушаал</label
            >
            <p class="mg-b-20">
              {{ log.user.departName }} / {{ log.user.position }}
            </p>
          </div>
          <div>
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >Хөтөч</label
            >
            <p class="mg-b-20" style="word-break: break-all;">
              {{ log.browser }}
            </p>
          </div>
          <div>
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >IP хаяг</label
            >
            <p class="mg-b-20">{{ log.ipAddress }}</p>
          </div>
          <div>
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >Origin</label
            >
            <p class="mg-b-20">{{ log.origin }}</p>
          </div>
          <div>
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >Path</label
            >
            <p class="mg-b-20">{{ log.path }}</p>
          </div>
          <div>
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >Method</label
            >
            <p class="mg-b-20">{{ log.method }}</p>
          </div>
          <div>
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >Query</label
            >
            <p class="mg-b-20" style="word-break: break-all;">
              {{ log.queries }}
            </p>
          </div>
          <div>
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >Body</label
            >
            <p class="mg-b-20" style="word-break: break-all;">{{ log.body }}</p>
          </div>
          <div v-if="ot == 2">
            <label
              class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
              >Алдаа</label
            >
            <p class="mg-b-20" style="word-break: break-all;">{{ log.ex }}</p>
          </div>

          <!-- <div class="row row-sm">
            <div class="col-sm-6">
              <label class="tx-uppercase tx-sans tx-11 tx-medium tx-spacing-1 tx-color-03">Эхлэх</label>
              <p class="event-start-date">{{current.startDate | moment('YYYY.MM.DD HH:mm dddd')}}</p>
            </div>
            <div class="col-sm-6">
              <label class="tx-uppercase tx-sans tx-11 tx-medium tx-spacing-1 tx-color-03">Дуусах</label>
              <p class="event-end-date">{{current.endDate | moment('YYYY.MM.DD HH:mm dddd')}}</p>
            </div>
          </div>

          <label class="tx-uppercase tx-sans tx-11 tx-medium tx-spacing-1 tx-color-03">Дэлгэрэнгүй</label>
          <p class="event-desc tx-gray-900">{{current.title}}</p>
          <p class="event-desc tx-gray-900 mg-b-40">{{current.course.name}}</p>-->
        </div>
        <div class="modal-footer pd-x-20 pd-y-15">
          <button type="button" class="btn btn-white" @click="cancel()">
            Хаах
          </button>
        </div>
      </div>
    </b-modal>

    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";
import { mapActions } from "vuex";

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker } from "element-ui";

export default {
  components: {
    vueCustomScrollbar, DatePicker, 
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    userSelectFinder: () => ({
      component: import("@/components/modules/userSelectFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data: () => ({
    forceLoad: false,
    ot: -1,
    mode: 0,
    fetched: false,
    loading: false,
    listSetting: {
      newBtnShow: true,
      statisticLoad: true,
      closeBtnShow: false,
      mainMenu: true,
      chooser: false
    },
    fileDialog: {
      show: false,
      id: 0
    },
    logsCount: 0,
    pager: {
      perPage: 50,
      current: 1
    },
    logDialog: {
      show: false,
      id: 0,
      key: 0
    },
    log: {},
    scrHeight: 600,
    scrSideHeight: 600,
    searchModel: {
      userId: "",
      ipAddress: "",
      path: "",
      page: 0,
      size: 50,
      start: null,
      end: null,
    },
    logs: [],
    fields: [
      {
        span: 5,
        title: "id"
      },
      {
        span: 15,
        title: "user"
      },
      {
        span: 15,
        title: "date"
      },
      {
        span: 15,
        title: "path"
      },
      {
        span: 15,
        title: "ip"
      },
      {
        span: 15,
        title: "browser"
      }
    ]
  }),
  props: {
    prms: {
      type: Object,
      default: () => {}
    }
  },
  beforeDestroy() {
    this.fields = [];
    window.removeEventListener("resize", this.getWindowHeight);
  },
  mounted() {
    if (this.prms != undefined && this.prms.objectTypeId != undefined) {
      this.forceLoad = true;
      this.$nextTick(() => {
        this.build(this.prms.objectTypeId);
      });
    } else {
      this.forceLoad = true;
      this.$nextTick(() => {
        this.build(this.$route.params.ot);
      });
    }
  },
  methods: {
    ...mapActions(["handleLoading", "handleUserInfoModal"]),
    userFinded() {
      //if(e!=null)
      this.search();
    },
    showDetail(l) {
      this.handleLoading({ isLoading: true });
      let url = "SystemConfig/RequestDetail";
      if (this.ot == 2) {
        url = "SystemConfig/ExceptionDetail";
      }
      request({
        api: { method: "GET", url: url },
        params: {
          id: l.id,
          start: this.searchModel.start,
          end: this.searchModel.end
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.log = res.data.log;
          this.logDialog.id = this.log.id;
          this.$nextTick(() => {
            this.logDialog.show = true;
          });
        }
      });
    },
    exportCoreHandle(){
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "GET", url: 'SystemConfig/RequestLogExport' },
        params: {
          start: this.searchModel.start,
          end: this.searchModel.end
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          //console.log('res', res);
          this.showFile(res.data.file.id);
        }
      });
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    search() {
      this.pager.current = 1;
      this.init();
    },
    cancel() {
      this.logDialog.id = 0;
      this.logDialog.show = false;
      //this.$nextTick(() => {});
    },
    getWindowHeight() {
      let extras =
        this.$refs.mainHeader.offsetHeight +
        this.$refs.listHeader.offsetHeight +
        this.$refs.listFooter.offsetHeight;
      let extraSide =
        this.$refs.mainHeader.offsetHeight +
        (this.listSetting.statisticLoad ? this.$refs.sideTop.offsetHeight : 0) +
        this.$refs.sideBtm.offsetHeight;

      this.scrHeight = window.innerHeight - extras;
      this.scrSideHeight = window.innerHeight - extraSide;
    },
    build(ot) {
      this.ot = ot;
      window.addEventListener("resize", this.getWindowHeight);
      this.getWindowHeight();
      this.init();
    },
    init(force) {
      if (force) {
        this.searchModel.userId = null;
        this.searchModel.ipAddress = "";
        this.searchModel.path = "";
        this.pager.current = 1;
      }

      this.handleLoading({ isLoading: true });
      let url = "SystemConfig/RequestLog";
      if (this.ot == 2) {
        url = "SystemConfig/ExceptionLog";
      }
      request({
        api: { method: "GET", url: url },
        params: {
          filterUserId: this.searchModel.userId,
          ipAddress: this.searchModel.ipAddress,
          path: this.searchModel.path,
          page: this.pager.current - 1,
          size: this.pager.perPage
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.logsCount = res.data.count;
          this.logs = res.data.list;
          this.$nextTick(() => {
            this.getWindowHeight();
          });

          //this.getTypeData();
        }
      });
    },
    pageChanged(e) {
      this.pager.current = e;
      this.init();
    },
    dispose() {
      Object.assign(this.$data, this.$options.data());
      window.removeEventListener("resize", this.getWindowHeight);
    }
  },
  watch: {
    "$root.$route"() {
      //console.log(newRoute);
      this.dispose();
      this.$nextTick(() => {
        this.forceLoad = true;
        this.$nextTick(() => {
          this.build(this.$route.params.ot);
        });
      });
    }
  }
};
</script>
<style scoped>
.list-row-selected {
  background: #cbecff;
}
</style>
